
import Header from "../components/header.jsx";
import AdminSidebar from "../components/adminSidebar.jsx";
import AdminUnpaidCustomer from "../components/adminUnpaidOperators.jsx";
import Footer from "../components/footer.jsx";

function AdminUnpaidCustomerPage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <AdminSidebar /> 
      < AdminUnpaidCustomer/> 
    </div>
    <Footer /> 
  </div>

  );
}
export default AdminUnpaidCustomerPage;
